// src/redux/slices/iframeSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  iframeUrl: null,
};

const iframeSlice = createSlice({
  name: "iframe",
  initialState,
  reducers: {
    setIframeUrl: (state, action) => {
      state.iframeUrl = action.payload;
    },
    clearIframeUrl: (state) => {
      state.iframeUrl = null;
    },
  },
});

export const { setIframeUrl, clearIframeUrl } = iframeSlice.actions;
export default iframeSlice.reducer;
